import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IntersectionObserverModule } from '../../directive/intersection-observer/intersection-observer.module';
import { LoadingModule } from '../../directive/loading/loading.module';
import { PipesModule } from '../../pipes/pipes.module';
import { CSButtonComponent } from '../cs-button/cs-button.component';
import { CsCurrencyConverterComponent } from '../cs-currency-converter/cs-currency-converter.component';
import { CsCurrencyUnitDisplayComponent } from '../cs-currency-unit-display/cs-currency-unit-display.component';
import { ImgCarouselModule } from '../img-carousel/img-carousel.module';
import { LazyImageComponent } from '../lazy-image/lazy-image.component';
import { OnlineNumberComponent } from '../online-number/online-number.component';
import { UserAvatarComponent } from '../user-avatar/user-avatar.component';
import { GameUnitComponent } from './game-unit/game-unit.component';
import { LatestWinnerUnitComponent } from './latest-winner-unit/latest-winner-unit.component';
import { OngoingUnitComponent } from './ongoing-unit/ongoing-unit.component';
import { SportUnitComponent } from './sport-unit/sport-unit.component';
import { SwiperProviderListComponent } from './swiper-provider-list/swiper-provider-list.component';
import { SwiperUnitComponent } from './swiper-unit.component';

@NgModule({
  imports: [
    CommonModule,
    IntersectionObserverModule,
    PipesModule,
    LoadingModule,
    ImgCarouselModule,
    LazyImageComponent,
    OnlineNumberComponent,
    CSButtonComponent,
    UserAvatarComponent,
    CsCurrencyConverterComponent,
    CsCurrencyUnitDisplayComponent,
  ],
  declarations: [
    SwiperUnitComponent,
    GameUnitComponent,
    SwiperProviderListComponent,
    SportUnitComponent,
    LatestWinnerUnitComponent,
    OngoingUnitComponent,
  ],
  exports: [SwiperUnitComponent, GameUnitComponent, SwiperProviderListComponent, LatestWinnerUnitComponent],
})
export class SwiperUnitModule {}
